var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app","lang":_vm.$i18n.locale}},[_c('keep-alive',{attrs:{"exclude":['ParticlePage', 'SolutionsPage']}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }